/**
 * AdeqoCart — unified cart API.
 *
 * Single entrypoint voor alle add-to-cart acties. Vuurt één
 * 'adeqo:cart:add' custom event per geslaagde call zodat tracking
 * (GA4, Meta Pixel, Klaviyo) één keer hoeft te worden aangesloten.
 *
 * Usage:
 *   AdeqoCart.add(
 *     [{ id: variantId, quantity: 1 }],
 *     { source: 'product-page' }
 *   )
 *   .then(response => { ... UI feedback ... })
 *   .catch(err => { ... error UI ... });
 *
 * Listen for tracking:
 *   document.addEventListener('adeqo:cart:add', e => {
 *     // e.detail.items     -> cart line items as returned by Shopify
 *     // e.detail.source    -> caller context (e.g. 'product-page', 'sample-configurator')
 *     // e.detail.requested -> the original {id, quantity} payload sent in
 *   });
 *   document.addEventListener('adeqo:cart:add:error', e => {
 *     // e.detail.error, e.detail.source, e.detail.requested
 *   });
 */
(function () {
  'use strict';

  function postCartAdd(items) {
    return fetch(window.theme && window.theme.routes ? window.theme.routes.cart_add + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          var msg = data.description || data.message || ('Cart add failed (' + response.status + ')');
          var err = new Error(msg);
          err.status = response.status;
          err.shopify = data;
          throw err;
        });
      }
      return response.json();
    });
  }

  function normalizeItems(response) {
    if (!response) return [];
    if (Array.isArray(response.items)) return response.items;
    if (response.id) return [response];
    return [];
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  window.AdeqoCart = window.AdeqoCart || {
    add: function (items, options) {
      options = options || {};
      var source = options.source || 'unknown';
      var requested = items;

      return postCartAdd(items)
        .then(function (response) {
          dispatch('adeqo:cart:add', {
            items: normalizeItems(response),
            requested: requested,
            source: source,
            response: response
          });

          if (typeof window.updateCartCount === 'function') {
            window.updateCartCount();
          }

          return response;
        })
        .catch(function (err) {
          dispatch('adeqo:cart:add:error', {
            error: err.message,
            status: err.status,
            shopify: err.shopify,
            requested: requested,
            source: source
          });
          throw err;
        });
    }
  };
})();
